import React from "react";
import { Box } from "@mui/material";
import HPButton from "../../../common/Button";

interface DrawerFooterProps {
  isCreatingChart: boolean;
  canSave: boolean;
  isRefetchingData: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

const DrawerFooter: React.FC<DrawerFooterProps> = ({
  isCreatingChart,
  canSave,
  isRefetchingData,
  onSave,
  onDiscard,
}) => {
  return (
    <Box
      sx={{
        p: 2,
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        gap: 1,
        justifyContent: "flex-end",
      }}
    >
      <HPButton variant="text" onClick={onDiscard}>
        Discard
      </HPButton>
      <HPButton
        variant="contained"
        onClick={onSave}
        disabled={!canSave || isRefetchingData}
      >
        {isCreatingChart ? "Save" : "Update"}
      </HPButton>
    </Box>
  );
};

export default DrawerFooter;
